import script from "./CompactOrderTable.vue?vue&type=script&lang=ts"
export * from "./CompactOrderTable.vue?vue&type=script&lang=ts"

import "./CompactOrderTable.vue?vue&type=style&index=0&id=1a150926&lang=css"
import "./CompactOrderTable.vue?vue&type=style&index=1&id=1a150926&lang=css"

const __exports__ = script;

export default __exports__